import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=4013d4a8&scoped=true&"
import script from "./Live.vue?vue&type=script&lang=ts&"
export * from "./Live.vue?vue&type=script&lang=ts&"
import style0 from "./Live.vue?vue&type=style&index=0&id=4013d4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013d4a8",
  null
  
)

export default component.exports